module.exports = __webpack_public_path__ + "static/media/views-icon.94ddb9e2.svg";